export interface Country {
  id: number;
  name: string;
  code: string;
  code3: string;
}

export const countries: Country[] = [
  { id: 1, name: 'Afghanistan', code: 'AF', code3: 'AFG' },
  { id: 2, name: 'Åland Islands', code: 'AX', code3: 'ALA' },
  { id: 3, name: 'Albania', code: 'AL', code3: 'ALB' },
  { id: 4, name: 'Algeria', code: 'DZ', code3: 'DZA' },
  { id: 5, name: 'American Samoa', code: 'AS', code3: 'ASM' },
  { id: 6, name: 'Andorra', code: 'AD', code3: 'AND' },
  { id: 7, name: 'Angola', code: 'AO', code3: 'AGO' },
  { id: 8, name: 'Anguilla', code: 'AI', code3: 'AIA' },
  { id: 9, name: 'Antarctica', code: 'AQ', code3: 'ATA' },
  { id: 10, name: 'Antigua and Barbuda', code: 'AG', code3: 'ATG' },
  { id: 11, name: 'Argentina', code: 'AR', code3: 'ARG' },
  { id: 12, name: 'Armenia', code: 'AM', code3: 'ARM' },
  { id: 13, name: 'Aruba', code: 'AW', code3: 'ABW' },
  { id: 14, name: 'Australia', code: 'AU', code3: 'AUS' },
  { id: 15, name: 'Austria', code: 'AT', code3: 'AUT' },
  { id: 16, name: 'Azerbaijan', code: 'AZ', code3: 'AZE' },
  { id: 17, name: 'Bahamas', code: 'BS', code3: 'BHS' },
  { id: 18, name: 'Bahrain', code: 'BH', code3: 'BHR' },
  { id: 19, name: 'Bangladesh', code: 'BD', code3: 'BGD' },
  { id: 20, name: 'Barbados', code: 'BB', code3: 'BRB' },
  { id: 21, name: 'Belarus', code: 'BY', code3: 'BLR' },
  { id: 22, name: 'Belgium', code: 'BE', code3: 'BEL' },
  { id: 23, name: 'Belize', code: 'BZ', code3: 'BLZ' },
  { id: 24, name: 'Benin', code: 'BJ', code3: 'BEN' },
  { id: 25, name: 'Bermuda', code: 'BM', code3: 'BMU' },
  { id: 26, name: 'Bhutan', code: 'BT', code3: 'BTN' },
  { id: 27, name: 'Bolivia, Plurinational State of', code: 'BO', code3: 'BOL' },
  { id: 28, name: 'Bonaire, Sint Eustatius and Saba', code: 'BQ', code3: 'BES' },
  { id: 29, name: 'Bosnia and Herzegovina', code: 'BA', code3: 'BIH' },
  { id: 30, name: 'Botswana', code: 'BW', code3: 'BWA' },
  { id: 31, name: 'Bouvet Island', code: 'BV', code3: 'BVT' },
  { id: 32, name: 'Brazil', code: 'BR', code3: 'BRA' },
  { id: 33, name: 'British Indian Ocean Territory', code: 'IO', code3: 'IOT' },
  { id: 34, name: 'Brunei Darussalam', code: 'BN', code3: 'BRN' },
  { id: 35, name: 'Bulgaria', code: 'BG', code3: 'BGR' },
  { id: 36, name: 'Burkina Faso', code: 'BF', code3: 'BFA' },
  { id: 37, name: 'Burundi', code: 'BI', code3: 'BDI' },
  { id: 38, name: 'Cambodia', code: 'KH', code3: 'KHM' },
  { id: 39, name: 'Cameroon', code: 'CM', code3: 'CMR' },
  { id: 40, name: 'Canada', code: 'CA', code3: 'CAN' },
  { id: 41, name: 'Cape Verde', code: 'CV', code3: 'CPV' },
  { id: 42, name: 'Cayman Islands', code: 'KY', code3: 'CYM' },
  { id: 43, name: 'Central African Republic', code: 'CF', code3: 'CAF' },
  { id: 44, name: 'Chad', code: 'TD', code3: 'TCD' },
  { id: 45, name: 'Chile', code: 'CL', code3: 'CHL' },
  { id: 46, name: 'China', code: 'CN', code3: 'CHN' },
  { id: 47, name: 'Christmas Island', code: 'CX', code3: 'CXR' },
  { id: 48, name: 'Cocos (Keeling) Islands', code: 'CC', code3: 'CCK' },
  { id: 49, name: 'Colombia', code: 'CO', code3: 'COL' },
  { id: 50, name: 'Comoros', code: 'KM', code3: 'COM' },
  { id: 51, name: 'Congo', code: 'CG', code3: 'COG' },
  { id: 52, name: 'Congo, the Democratic Republic of the', code: 'CD', code3: 'COD' },
  { id: 53, name: 'Cook Islands', code: 'CK', code3: 'COK' },
  { id: 54, name: 'Costa Rica', code: 'CR', code3: 'CRI' },
  { id: 55, name: "Cote d'Ivoire", code: 'CI', code3: 'CIV' },
  { id: 56, name: 'Croatia', code: 'HR', code3: 'HRV' },
  { id: 57, name: 'Cuba', code: 'CU', code3: 'CUB' },
  { id: 58, name: 'Curacao', code: 'CW', code3: 'CUW' },
  { id: 59, name: 'Cyprus', code: 'CY', code3: 'CYP' },
  { id: 60, name: 'Czech Republic', code: 'CZ', code3: 'CZE' },
  { id: 61, name: 'Denmark', code: 'DK', code3: 'DNK' },
  { id: 62, name: 'Djibouti', code: 'DJ', code3: 'DJI' },
  { id: 63, name: 'Dominica', code: 'DM', code3: 'DMA' },
  { id: 64, name: 'Dominican Republic', code: 'DO', code3: 'DOM' },
  { id: 65, name: 'Ecuador', code: 'EC', code3: 'ECU' },
  { id: 66, name: 'Egypt', code: 'EG', code3: 'EGY' },
  { id: 67, name: 'El Salvador', code: 'SV', code3: 'SLV' },
  { id: 68, name: 'Equatorial Guinea', code: 'GQ', code3: 'GNQ' },
  { id: 69, name: 'Eritrea', code: 'ER', code3: 'ERI' },
  { id: 70, name: 'Estonia', code: 'EE', code3: 'EST' },
  { id: 71, name: 'Ethiopia', code: 'ET', code3: 'ETH' },
  { id: 72, name: 'Falkland Islands (Malvinas)', code: 'FK', code3: 'FLK' },
  { id: 73, name: 'Faroe Islands', code: 'FO', code3: 'FRO' },
  { id: 74, name: 'Fiji', code: 'FJ', code3: 'FJI' },
  { id: 75, name: 'Finland', code: 'FI', code3: 'FIN' },
  { id: 76, name: 'France', code: 'FR', code3: 'FRA' },
  { id: 77, name: 'French Guiana', code: 'GF', code3: 'GUF' },
  { id: 78, name: 'French Polynesia', code: 'PF', code3: 'PYF' },
  { id: 79, name: 'French Southern Territories', code: 'TF', code3: 'ATF' },
  { id: 80, name: 'Gabon', code: 'GA', code3: 'GAB' },
  { id: 81, name: 'Gambia', code: 'GM', code3: 'GMB' },
  { id: 82, name: 'Georgia', code: 'GE', code3: 'GEO' },
  { id: 83, name: 'Germany', code: 'DE', code3: 'DEU' },
  { id: 84, name: 'Ghana', code: 'GH', code3: 'GHA' },
  { id: 85, name: 'Gibraltar', code: 'GI', code3: 'GIB' },
  { id: 86, name: 'Greece', code: 'GR', code3: 'GRC' },
  { id: 87, name: 'Greenland', code: 'GL', code3: 'GRL' },
  { id: 88, name: 'Grenada', code: 'GD', code3: 'GRD' },
  { id: 89, name: 'Guadeloupe', code: 'GP', code3: 'GLP' },
  { id: 90, name: 'Guam', code: 'GU', code3: 'GUM' },
  { id: 91, name: 'Guatemala', code: 'GT', code3: 'GTM' },
  { id: 92, name: 'Guernsey', code: 'GG', code3: 'GGY' },
  { id: 93, name: 'Guinea', code: 'GN', code3: 'GIN' },
  { id: 94, name: 'Guinea-Bissau', code: 'GW', code3: 'GNB' },
  { id: 95, name: 'Guyana', code: 'GY', code3: 'GUY' },
  { id: 96, name: 'Haiti', code: 'HT', code3: 'HTI' },
  { id: 97, name: 'Heard Island and McDonald Islands', code: 'HM', code3: 'HMD' },
  { id: 98, name: 'Holy See (Vatican City State)', code: 'VA', code3: 'VAT' },
  { id: 99, name: 'Honduras', code: 'HN', code3: 'HND' },
  { id: 100, name: 'Hong Kong', code: 'HK', code3: 'HKG' },
  { id: 101, name: 'Hungary', code: 'HU', code3: 'HUN' },
  { id: 102, name: 'Iceland', code: 'IS', code3: 'ISL' },
  { id: 103, name: 'India', code: 'IN', code3: 'IND' },
  { id: 104, name: 'Indonesia', code: 'ID', code3: 'IDN' },
  { id: 105, name: 'Iran, Islamic Republic of', code: 'IR', code3: 'IRN' },
  { id: 106, name: 'Iraq', code: 'IQ', code3: 'IRQ' },
  { id: 107, name: 'Ireland', code: 'IE', code3: 'IRL' },
  { id: 108, name: 'Isle of Man', code: 'IM', code3: 'IMN' },
  { id: 109, name: 'Israel', code: 'IL', code3: 'ISR' },
  { id: 110, name: 'Italy', code: 'IT', code3: 'ITA' },
  { id: 111, name: 'Jamaica', code: 'JM', code3: 'JAM' },
  { id: 112, name: 'Japan', code: 'JP', code3: 'JPN' },
  { id: 113, name: 'Jersey', code: 'JE', code3: 'JEY' },
  { id: 114, name: 'Jordan', code: 'JO', code3: 'JOR' },
  { id: 115, name: 'Kazakhstan', code: 'KZ', code3: 'KAZ' },
  { id: 116, name: 'Kenya', code: 'KE', code3: 'KEN' },
  { id: 117, name: 'Kiribati', code: 'KI', code3: 'KIR' },
  { id: 118, name: "Korea, Democratic People's Republic of", code: 'KP', code3: 'PRK' },
  { id: 119, name: 'Korea, Republic of', code: 'KR', code3: 'KOR' },
  { id: 120, name: 'Kuwait', code: 'KW', code3: 'KWT' },
  { id: 121, name: 'Kyrgyzstan', code: 'KG', code3: 'KGZ' },
  { id: 122, name: "Lao People's Democratic Republic", code: 'LA', code3: 'LAO' },
  { id: 123, name: 'Latvia', code: 'LV', code3: 'LVA' },
  { id: 124, name: 'Lebanon', code: 'LB', code3: 'LBN' },
  { id: 125, name: 'Lesotho', code: 'LS', code3: 'LSO' },
  { id: 126, name: 'Liberia', code: 'LR', code3: 'LBR' },
  { id: 127, name: 'Libya', code: 'LY', code3: 'LBY' },
  { id: 128, name: 'Liechtenstein', code: 'LI', code3: 'LIE' },
  { id: 129, name: 'Lithuania', code: 'LT', code3: 'LTU' },
  { id: 130, name: 'Luxembourg', code: 'LU', code3: 'LUX' },
  { id: 131, name: 'Macao', code: 'MO', code3: 'MAC' },
  { id: 132, name: 'Macedonia, the former Yugoslav Republic of', code: 'MK', code3: 'MKD' },
  { id: 133, name: 'Madagascar', code: 'MG', code3: 'MDG' },
  { id: 134, name: 'Malawi', code: 'MW', code3: 'MWI' },
  { id: 135, name: 'Malaysia', code: 'MY', code3: 'MYS' },
  { id: 136, name: 'Maldives', code: 'MV', code3: 'MDV' },
  { id: 137, name: 'Mali', code: 'ML', code3: 'MLI' },
  { id: 138, name: 'Malta', code: 'MT', code3: 'MLT' },
  { id: 139, name: 'Marshall Islands', code: 'MH', code3: 'MHL' },
  { id: 140, name: 'Martinique', code: 'MQ', code3: 'MTQ' },
  { id: 141, name: 'Mauritania', code: 'MR', code3: 'MRT' },
  { id: 142, name: 'Mauritius', code: 'MU', code3: 'MUS' },
  { id: 143, name: 'Mayotte', code: 'YT', code3: 'MYT' },
  { id: 144, name: 'Mexico', code: 'MX', code3: 'MEX' },
  { id: 145, name: 'Micronesia, Federated States of', code: 'FM', code3: 'FSM' },
  { id: 146, name: 'Moldova, Republic of', code: 'MD', code3: 'MDA' },
  { id: 147, name: 'Monaco', code: 'MC', code3: 'MCO' },
  { id: 148, name: 'Mongolia', code: 'MN', code3: 'MNG' },
  { id: 149, name: 'Montenegro', code: 'ME', code3: 'MNE' },
  { id: 150, name: 'Montserrat', code: 'MS', code3: 'MSR' },
  { id: 151, name: 'Morocco', code: 'MA', code3: 'MAR' },
  { id: 152, name: 'Mozambique', code: 'MZ', code3: 'MOZ' },
  { id: 153, name: 'Myanmar', code: 'MM', code3: 'MMR' },
  { id: 154, name: 'Namibia', code: 'NA', code3: 'NAM' },
  { id: 155, name: 'Nauru', code: 'NR', code3: 'NRU' },
  { id: 156, name: 'Nepal', code: 'NP', code3: 'NPL' },
  { id: 157, name: 'Netherlands', code: 'NL', code3: 'NLD' },
  { id: 158, name: 'New Caledonia', code: 'NC', code3: 'NCL' },
  { id: 159, name: 'New Zealand', code: 'NZ', code3: 'NZL' },
  { id: 160, name: 'Nicaragua', code: 'NI', code3: 'NIC' },
  { id: 161, name: 'Niger', code: 'NE', code3: 'NER' },
  { id: 162, name: 'Nigeria', code: 'NG', code3: 'NGA' },
  { id: 163, name: 'Niue', code: 'NU', code3: 'NIU' },
  { id: 164, name: 'Norfolk Island', code: 'NF', code3: 'NFK' },
  { id: 165, name: 'Northern Mariana Islands', code: 'MP', code3: 'MNP' },
  { id: 166, name: 'Norway', code: 'NO', code3: 'NOR' },
  { id: 167, name: 'Oman', code: 'OM', code3: 'OMN' },
  { id: 168, name: 'Pakistan', code: 'PK', code3: 'PAK' },
  { id: 169, name: 'Palau', code: 'PW', code3: 'PLW' },
  { id: 170, name: 'Palestine, State of', code: 'PS', code3: 'PSE' },
  { id: 171, name: 'Panama', code: 'PA', code3: 'PAN' },
  { id: 172, name: 'Papua New Guinea', code: 'PG', code3: 'PNG' },
  { id: 173, name: 'Paraguay', code: 'PY', code3: 'PRY' },
  { id: 174, name: 'Peru', code: 'PE', code3: 'PER' },
  { id: 175, name: 'Philippines', code: 'PH', code3: 'PHL' },
  { id: 176, name: 'Pitcairn', code: 'PN', code3: 'PCN' },
  { id: 177, name: 'Poland', code: 'PL', code3: 'POL' },
  { id: 178, name: 'Portugal', code: 'PT', code3: 'PRT' },
  { id: 179, name: 'Puerto Rico', code: 'PR', code3: 'PRI' },
  { id: 180, name: 'Qatar', code: 'QA', code3: 'QAT' },
  { id: 181, name: 'Reunion', code: 'RE', code3: 'REU' },
  { id: 182, name: 'Romania', code: 'RO', code3: 'ROU' },
  { id: 183, name: 'Russian Federation', code: 'RU', code3: 'RUS' },
  { id: 184, name: 'Rwanda', code: 'RW', code3: 'RWA' },
  { id: 185, name: 'Saint Barthelemy', code: 'BL', code3: 'BLM' },
  { id: 186, name: 'Saint Helena, Ascension and Tristan da Cunha', code: 'SH', code3: 'SHN' },
  { id: 187, name: 'Saint Kitts and Nevis', code: 'KN', code3: 'KNA' },
  { id: 188, name: 'Saint Lucia', code: 'LC', code3: 'LCA' },
  { id: 189, name: 'Saint Martin (French part)', code: 'MF', code3: 'MAF' },
  { id: 190, name: 'Saint Pierre and Miquelon', code: 'PM', code3: 'SPM' },
  { id: 191, name: 'Saint Vincent and the Grenadines', code: 'VC', code3: 'VCT' },
  { id: 192, name: 'Samoa', code: 'WS', code3: 'WSM' },
  { id: 193, name: 'San Marino', code: 'SM', code3: 'SMR' },
  { id: 194, name: 'Sao Tome and Principe', code: 'ST', code3: 'STP' },
  { id: 195, name: 'Saudi Arabia', code: 'SA', code3: 'SAU' },
  { id: 196, name: 'Senegal', code: 'SN', code3: 'SEN' },
  { id: 197, name: 'Serbia', code: 'RS', code3: 'SRB' },
  { id: 198, name: 'Seychelles', code: 'SC', code3: 'SYC' },
  { id: 199, name: 'Sierra Leone', code: 'SL', code3: 'SLE' },
  { id: 200, name: 'Singapore', code: 'SG', code3: 'SGP' },
  { id: 201, name: 'Sint Maarten (Dutch part)', code: 'SX', code3: 'SXM' },
  { id: 202, name: 'Slovakia', code: 'SK', code3: 'SVK' },
  { id: 203, name: 'Slovenia', code: 'SI', code3: 'SVN' },
  { id: 204, name: 'Solomon Islands', code: 'SB', code3: 'SLB' },
  { id: 205, name: 'Somalia', code: 'SO', code3: 'SOM' },
  { id: 206, name: 'South Africa', code: 'ZA', code3: 'ZAF' },
  { id: 207, name: 'South Georgia and the South Sandwich Islands', code: 'GS', code3: 'SGS' },
  { id: 208, name: 'South Sudan', code: 'SS', code3: 'SSD' },
  { id: 209, name: 'Spain', code: 'ES', code3: 'ESP' },
  { id: 210, name: 'Sri Lanka', code: 'LK', code3: 'LKA' },
  { id: 211, name: 'Sudan', code: 'SD', code3: 'SDN' },
  { id: 212, name: 'Suriname', code: 'SR', code3: 'SUR' },
  { id: 213, name: 'Svalbard and Jan Mayen', code: 'SJ', code3: 'SJM' },
  { id: 214, name: 'Swaziland', code: 'SZ', code3: 'SWZ' },
  { id: 215, name: 'Sweden', code: 'SE', code3: 'SWE' },
  { id: 216, name: 'Switzerland', code: 'CH', code3: 'CHE' },
  { id: 217, name: 'Syrian Arab Republic', code: 'SY', code3: 'SYR' },
  { id: 218, name: 'Taiwan, Province of China', code: 'TW', code3: 'TWN' },
  { id: 219, name: 'Tajikistan', code: 'TJ', code3: 'TJK' },
  { id: 220, name: 'Tanzania, United Republic of', code: 'TZ', code3: 'TZA' },
  { id: 221, name: 'Thailand', code: 'TH', code3: 'THA' },
  { id: 222, name: 'Timor-Leste', code: 'TL', code3: 'TLS' },
  { id: 223, name: 'Togo', code: 'TG', code3: 'TGO' },
  { id: 224, name: 'Tokelau', code: 'TK', code3: 'TKL' },
  { id: 225, name: 'Tonga', code: 'TO', code3: 'TON' },
  { id: 226, name: 'Trinidad and Tobago', code: 'TT', code3: 'TTO' },
  { id: 227, name: 'Tunisia', code: 'TN', code3: 'TUN' },
  { id: 228, name: 'Turkey', code: 'TR', code3: 'TUR' },
  { id: 229, name: 'Turkmenistan', code: 'TM', code3: 'TKM' },
  { id: 230, name: 'Turks and Caicos Islands', code: 'TC', code3: 'TCA' },
  { id: 231, name: 'Tuvalu', code: 'TV', code3: 'TUV' },
  { id: 232, name: 'Uganda', code: 'UG', code3: 'UGA' },
  { id: 233, name: 'Ukraine', code: 'UA', code3: 'UKR' },
  { id: 234, name: 'United Arab Emirates', code: 'AE', code3: 'ARE' },
  { id: 235, name: 'United Kingdom', code: 'GB', code3: 'GBR' },
  { id: 236, name: 'United States', code: 'US', code3: 'USA' },
  { id: 237, name: 'United States Minor Outlying Islands', code: 'UM', code3: 'UMI' },
  { id: 238, name: 'Uruguay', code: 'UY', code3: 'URY' },
  { id: 239, name: 'Uzbekistan', code: 'UZ', code3: 'UZB' },
  { id: 240, name: 'Vanuatu', code: 'VU', code3: 'VUT' },
  { id: 241, name: 'Venezuela, Bolivarian Republic of', code: 'VE', code3: 'VEN' },
  { id: 242, name: 'Viet Nam', code: 'VN', code3: 'VNM' },
  { id: 243, name: 'Virgin Islands, British', code: 'VG', code3: 'VGB' },
  { id: 244, name: 'Virgin Islands, U.S.', code: 'VI', code3: 'VIR' },
  { id: 245, name: 'Wallis and Futuna', code: 'WF', code3: 'WLF' },
  { id: 246, name: 'Western Sahara', code: 'EH', code3: 'ESH' },
  { id: 247, name: 'Yemen', code: 'YE', code3: 'YEM' },
  { id: 248, name: 'Zambia', code: 'ZM', code3: 'ZMB' },
  { id: 249, name: 'Zimbabwe', code: 'ZW', code3: 'ZWE' },
];
